<app-modal class="app-modal--contains-dropdown">

  <h2 class="mb-0075">Add Info</h2>

  <ng-container *ngIf="!selectedCategory">
    <app-field-search-inline (itemSelected)="setCategory($event)"
                             [hideReadonly]="true"
                             [targetType]="data.targetType"
                             [targetTypeId]="data.targetTypeId"
                             [campaignId]="data.campaignId"
                             class="d-block border-1 border-radius"></app-field-search-inline>
  </ng-container>

  <ng-container *ngIf="selectedCategory">
    <div class="mimic-mat-form-field flex flexAlign--center flexJustify--between pl-0075 mb-0150">
      <span class="truncate"> {{selectedCategory?.name}} </span>
      <button mat-icon-button
              (click)="setCategory(null)">
        <mat-icon fontSet="fal"
                  fontIcon="fa-times"
                  class="color--gray--007"></mat-icon>
      </button>
    </div>


    <app-apply-tag [campaignId]="data.campaignId"
                   [targetType]="entityOrConnection"
                   [targetTypeId]="data.targetTypeId"
                   [targetId]="data.targetId"
                   (changesSaved)="close()"
                   [tagCategory]="selectedCategory">
    </app-apply-tag>

  </ng-container>

</app-modal>
